/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrdata1Inputs */

const en_qrdata1 = /** @type {(inputs: Qrdata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link or text`)
};

const de_qrdata1 = /** @type {(inputs: Qrdata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link oder Text`)
};

/**
* | output |
* | --- |
* | "Link or text" |
*
* @param {Qrdata1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrdata1 = /** @type {((inputs?: Qrdata1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrdata1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrdata1(inputs)
	return de_qrdata1(inputs)
});
export { qrdata1 as "qrData" }